const currencyFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
})

const dateFormatter = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
})

/** Placeholder formatters — ready for domain usage later. */
export function formatCurrency(value: number): string {
  return currencyFormatter.format(value)
}

export function formatDate(value: Date | string): string {
  const date = typeof value === 'string' ? new Date(value) : value
  return dateFormatter.format(date)
}

export function formatRelative(_value: Date | string): string {
  // Intentionally minimal — relative time logic deferred
  return formatDate(_value)
}
